import { LogType } from './index';
import ElectronLog from 'electron-log';

const log = (scope: string, type: LogType, ...args: any[]) => {
  const userLog = ElectronLog.scope(scope)
  userLog[type](...args);
};

export default log;
